import React from 'react';
import PropTypes from 'prop-types';
import ListSubheader from '@material-ui/core/ListSubheader';
import Typography from '@material-ui/core/Typography';
import isDefined from '@afosto/utils/isDefined';

const Property = ({ label, value, valueTypographyProps, labelTypographyProps }) => (
  <>
    <ListSubheader component="div" disableGutters disableSticky>
      <Typography variant="overline" color="textSecondary" {...labelTypographyProps}>
        {label}
      </Typography>
    </ListSubheader>
    <Typography component="div" variant="body2" {...valueTypographyProps}>
      {isDefined(value) ? value : '-'}
    </Typography>
  </>
);

Property.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  valueTypographyProps: PropTypes.object,
  labelTypographyProps: PropTypes.object,
};

Property.defaultProps = {
  value: undefined,
  valueTypographyProps: {},
  labelTypographyProps: {},
};

export default Property;
